import IVueInstance from '@/module/common/models/IVueInstance';

function getLocalisationVue2<T>(key: string, vueInstance: IVueInstance): T {
  return vueInstance?.$t(key) as T;
}

export default getLocalisationVue2;
